"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = isCssVariable;
exports.isWrappedCssVariable = isWrappedCssVariable;
exports.unwrapCssVariable = unwrapCssVariable;
exports.cssVar = cssVar;
exports.stripUnit = stripUnit;
exports.extractCssVariable = extractCssVariable;
/**
 * Whether the value is a CSS variable.
 *
 * @param value the value to check
 */
const exenv_1 = require("exenv");
/**
 * Whether the value is a CSS variable.
 *
 * @param value the value to check
 */
function isCssVariable(value) {
    return value.startsWith('--');
}
/**
 * Checks if CSS variable is wrapped.
 *
 * @param value
 * @returns
 */
function isWrappedCssVariable(value) {
    return value.startsWith('var(--');
}
/**
 * Unwraps CSS variable removing the 'var(...)'.
 *
 * @param value
 * @returns
 */
function unwrapCssVariable(value) {
    const match = value.match(/var\(([\d\s,a-z-]+)\)/);
    if (match) {
        return match[1];
    }
    return value;
}
function cssVar(cssVariable, defaultValue, element = exenv_1.canUseDOM ? document.documentElement : null) {
    let variableValue;
    if (exenv_1.canUseDOM && element !== null) {
        variableValue = getComputedStyle(element).getPropertyValue(cssVariable);
    }
    return variableValue ? variableValue.trim() : defaultValue;
}
const cssRegex = /^([+-]?(?:\d+|\d*\.\d+))([a-z]*|%)$/;
/**
 * Returns a given CSS value minus its unit of measure.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   '--dimension': stripUnit('100px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   --dimension: ${stripUnit('100px')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   '--dimension': 100
 * }
 */
function stripUnit(value) {
    if (typeof value !== 'string') {
        return value;
    }
    const matchedValue = value.match(cssRegex);
    return matchedValue ? Number.parseFloat(value) : value;
}
/**
 * Extracts the CSS variable name from the value.
 *
 * @param cssVariable
 * @param defaultValue
 * @param element
 * @returns
 */
function extractCssVariable(cssVariable, defaultValue, element = exenv_1.canUseDOM ? document.documentElement : null) {
    let cssVariableToUse = cssVariable;
    if (isWrappedCssVariable(cssVariable)) {
        cssVariableToUse = cssVariableToUse.slice(4, cssVariable.length - 1);
    }
    return cssVar(cssVariableToUse, defaultValue, element);
}
//# sourceMappingURL=CssVariableHelper.js.map